function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import TriangleWithColor from "segments/desktop/core-components/triangle-with-color/triangle-with-color";
import { MD } from "constants/sizes";
import { themes } from "segments/segments-service";
import { StyledAsymmetricSideBySideTextAndAssetComponent } from "./asymmetric-side-by-side-text-and-asset-component.scss";
class AsymmetricSideBySideTextAndAssetComponent extends PureComponent {
    render() {
        const _this_props = this.props, { theme } = _this_props, restProps = _object_without_properties(_this_props, [
            "theme"
        ]);
        const background = {
            color: theme,
            width: "100%"
        };
        return /*#__PURE__*/ _jsxs(StyledAsymmetricSideBySideTextAndAssetComponent, {
            className: "asymmetric-side-by-side-text-and-asset-component",
            children: [
                /*#__PURE__*/ _jsx(TriangleWithColor, {
                    color: themes[theme].background
                }),
                /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread_props(_object_spread({}, restProps), {
                    background: background,
                    contentClassName: "asymmetric-side-by-side-text-and-asset-content"
                }))
            ]
        });
    }
}
export { AsymmetricSideBySideTextAndAssetComponent as default };
AsymmetricSideBySideTextAndAssetComponent.defaultProps = _object_spread_props(_object_spread({}, SideBySideTextAndAsset.defaultProps), {
    theme: "enterprise",
    titleSize: MD,
    textSize: MD
});
